import { styled, Typography, Tooltip } from "@mui/material";
import { intervalToDuration } from "date-fns";
import { CalendarBlockEventStatusEnum } from "~/graphql/__generated__/graphql";
import { LocalCalendarBlock } from "~/hooks/visitDragDropReducer";
import { formatInterval } from "@caredna-marlin/utils/dates";
import LocationTooltip from "~/components/command/LocationTooltip";
import { useOrgConfig } from "~/providers/OrgConfigProvider";
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import { StatusBgMap } from "~/utils/statuses";

type CalendarBlockFilteringProps = {
  date: Date;
  calendarBlock: LocalCalendarBlock;
  eventStatus: CalendarBlockEventStatusEnum;
};

const CalendarBlockFiltering: React.FC<CalendarBlockFilteringProps> = ({ calendarBlock }) => {
  const start = new Date(calendarBlock.startTime);
  const end = new Date(calendarBlock.endTime);

  const { visitTypes: visitTypeByKey } = useOrgConfig();

  const blockName = calendarBlock.title || "Block";
  const duration = (end && start) ? intervalToDuration({ start, end }) : {};
  const label = blockName + " - " + formatInterval(duration)

  const visitTypes = calendarBlock.filters?.visitTypeIds?.map((vt) => visitTypeByKey[vt]);
  const canceled = StatusBgMap.canceled + '44';
  const background = calendarBlock.eventStatus === CalendarBlockEventStatusEnum.Scheduled ? "rgba(0, 0, 0, 0.08)" : `repeating-linear-gradient(-45deg, #fff, #fff 11px, ${canceled} 11px, ${canceled} 22px)`;

  return <CustomContainer style={{ background: background }}>
    <Typography variant="body2" component="span" sx={{ fontWeight: "normal", color: "black" }}>{label}</Typography>
    {visitTypes && visitTypes?.length > 0 && (
      <>
        <Tooltip 
          title={
            <div>
              <div>Allowed visit types:</div>
              <ul style={{marginTop: 5, paddingLeft: 20}}>
              {visitTypes.map((vt, index) => (
                <li key={index}>{vt?.name}</li>
              ))}
              </ul>
            </div>
          }
          arrow
          placement="top"
        >
          <MedicalInformationIcon 
            sx={{ ml: 1, color: 'gray', width: 18, verticalAlign: 'bottom' }} 
          />
        </Tooltip>
      </>
    )}
    {calendarBlock.addressStreet && (
      <LocationTooltip
        preText='Allows visits at: '
        address={{
          addressStreet: calendarBlock.addressStreet,
          addressCity: calendarBlock.addressCity,
          addressState: calendarBlock.addressState,
          addressZip: calendarBlock.addressZip
        }} 
      />
    )}
  </CustomContainer>;
};

export default CalendarBlockFiltering

const CustomContainer = styled("div")`
  width: 100%;
  min-height: 20px;
  padding: 2px 2px 2px 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
